module.exports = __webpack_public_path__ + "img/fourday1-3.367b8c87.jpg";